import { OrdersState } from './state';
import { OrdersActionsUnion, OrdersActionTypes } from './actions';
import { DealActionTypes, DealActionsUnion } from '../deal/actions';
export const ordersDefaultState: OrdersState = {
  dealId: undefined,
  orders: undefined,
  loaded: false,
  loading: false,
  error: undefined
};

export function ordersReducer(
  state = ordersDefaultState,
  action: OrdersActionsUnion | DealActionsUnion
): OrdersState {
  switch (action.type) {
    case OrdersActionTypes.Load:
      return {
        ...state,
        dealId: action.payload.dealId,
        orders:
          action.payload.dealId === state.dealId ? state.orders : undefined,
        loading: true,
        loaded: action.payload.reload ? state.loaded : false,
        error: action.payload.dealId === state.dealId ? state.error : undefined
      };
    case OrdersActionTypes.LoadSuccess:
      return {
        ...state,
        orders: action.payload,
        loaded: true,
        loading: false,
        error: undefined
      };
    case OrdersActionTypes.LoadFail:
      return {
        ...state,
        orders: undefined,
        loaded: false,
        loading: false,
        error: action.payload
      };
    case DealActionTypes.Reset:
      return ordersDefaultState;
    default:
      return state;
  }
}

export const getOrders = (state: OrdersState) => state.orders;
